<template>
    <div :class="applicantTopBlockClasses(client.status)">
        <div class="left-side  w-100">
            <div class="left-side-info">
                <div class="person-info-wrap sites-info-wrap">
                    <div class="person-info">
                        <div class="name">{{ client.name }}</div>
                        <div class="contacts">
                            <img src="/img/svg/icons-location.svg" alt="">
                            {{client.address}}, {{ client.city }}, {{ client.state }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";

export default {
    name: 'ClientInfoBlock',
    mixins: [StyleHandler,],
    props: {
        client: {
            type: Object,
            required: true,
        }
    },
}

</script>


<style scoped>

</style>
